<template>
  <div>
    <b-alert v-if="errorMessage" show variant="danger">{{ errorMessage }}</b-alert>

    <b-table
      :items="items"
      :fields="fields"
      :busy="loading"
      primary-key="request_id"
      responsive
      hover
      show-empty
      empty-text="Sin solicitudes en el periodo."
    >
      <template #table-busy>
        <div class="text-center text-primary my-2">
          <b-spinner class="align-middle"></b-spinner>
        </div>
      </template>

      <template #cell(status)="{ item }">
        <b-badge :variant="badge(item.status).variant">{{ badge(item.status).text }}</b-badge>
      </template>

      <template #cell(type_visit)="{ item }">
        {{ item.type_visit || '—' }}
      </template>
    </b-table>

    <PaginationTable
      :dataMeta="dataMeta"
      :totalUsers="total"
      :perPage="perPage"
      :currentPage="currentPage"
      @page-changed="load"
    />
  </div>
</template>

<script>
import { BAlert, BBadge, BSpinner, BTable } from 'bootstrap-vue'
import agentPlanService from '@/core/services/api/agentPlan'
import PaginationTable from '@/components/PaginationTable'
import { REQUEST_STATUS_COPY, rangeParams, statusBadge } from '@/core/utils/agentPlanDashboard'
import pagedList from './pagedList'

/** Solicitudes de cita del agente. El tipo de visita llega solo en las aceptadas. */
export default {
  name: 'AgentRequestsTable',
  components: { BAlert, BBadge, BSpinner, BTable, PaginationTable },
  mixins: [pagedList],
  props: {
    range: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      fields: [
        { key: 'patient_name', label: 'Paciente' },
        { key: 'requested_date', label: 'Fecha pedida' },
        { key: 'facility', label: 'Sede' },
        { key: 'status', label: 'Estado' },
        { key: 'type_visit', label: 'Tipo de visita' },
        { key: 'requested_at', label: 'Solicitada el' },
      ],
    }
  },
  watch: {
    range() {
      this.load(1)
    },
  },
  methods: {
    fetchPage(params) {
      return agentPlanService.getRequests(params)
    },
    extraParams() {
      return rangeParams(this.range)
    },
    badge(status) {
      return statusBadge(REQUEST_STATUS_COPY, status)
    },
  },
}
</script>
